module.exports = __webpack_public_path__ + "static/media/10C-0@3x.3305d9db.png";